
export default function ExperienceHero() {
  return (
    <section 
      className="relative h-96 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/aceeec0dd406b120da0ff666a4d576b6.jpg')`
      }}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center text-white max-w-4xl px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Unforgettable Experiences</h1>
          <p className="text-xl md:text-2xl mb-8 leading-relaxed">
            Discover luxury glamping adventures across breathtaking landscapes. From forest sanctuaries to desert oases, 
            each experience is crafted for the discerning outdoor enthusiast.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Explore All Experiences
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Plan Custom Trip
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
